/* eslint-disable */
import MobileDetect from 'mobile-detect';
import CallApp from 'callapp-lib';
import router from '@/router/index';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import store from '@/store/index';
import qs from 'qs';
import { apiShareVideoInfo } from '@/api/common/index';

Vue.use(VueCookies);

const vue = new Vue();

const options = {
  scheme: {
    protocol: 'wedoctorlive',
  },
  intent: {
    package: 'com.wedoctor.techbridge.live',
    scheme: 'wedoctorlive',
  },
  appstore: 'https://apps.apple.com/cn/app/%E5%BE%AE%E5%8C%BB%E7%9B%B4%E6%92%AD/id1525196013',
  yingyongbao: '',
  fallback: window.location.href,
  timeout: 2000,
};
// const androidOptions = {
//   scheme: {
//     protocol: 'android',
//   },
//   intent: {
//     package: 'com.wedoctor.techbridge.live',
//     scheme: 'wedoctorlive',
//   },
//   appstore: '',
//   yingyongbao: '',
//   fallback: window.location.href,
//   timeout: 2000,
// };
const callLib = new CallApp(options);

const md = new MobileDetect(window.navigator.userAgent);
export const isiPhone = md.is('iPhone');

export const isWeChatClient = md.match('MicroMessenger');
export const isQQClient = md.match('QQ');

export const openApp = () => {
  // todo: 安卓打开APP注释
  if (!isiPhone) {
    return;
  }
  if (isWeChatClient || isQQClient) {
    router.push('wxShare');
  } else {
    if (isiPhone) {
      callLib.open({
        path: '',
        param: {}, //要传递的参数
      });
    } else {
      // window.location.href = callLib.generateIntent({ path: 'open' });
    }
  }
};

export const reportVideoViewHeader = () => {
  if (!window.sessionStorage.getItem('os-token-id')) {
    window.sessionStorage.setItem('os-token-id', new Date().getTime());
  }
  return window.sessionStorage.getItem('os-token-id');
};

// 不提示的接口
const notTipUrl = [
  '/user/home/get',
  '/im/getImUserToken',
  '/user/view/report',
  '/live/addPointup',
  '/user/code/send',
  '/comment/getCommentList',
  '/user/code/login',
  '/user/live/notice/find',
  '/user/view/report/liveReport',
  '/live/getLivePullUrl',
  '/api/user/self/get',
  '/user/userFollow/isFollow',
  '/vod/isAlreadyPointup',
  '/video/getVodVideoInfo',
  '/user/blacklist/state',
];

// 不跳转登录页面的接口
const noGoLoginurl = [
  '/user/userFollow/isFollow',
  '/vod/isAlreadyPointup',
  '/im/getImUserToken',
  '/live/getLivePullUrl',
];

export const apiNotTip = url => {
  if (notTipUrl.indexOf(url) !== -1) {
    return true;
  }
  return false;
};

export const apiNoGoLoginurl = url => {
  if (noGoLoginurl.indexOf(url) !== -1) {
    return true;
  }
  return false;
};

// 手机验证
export const validatePhoneNumber = str => {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(str);
};

// 登录跳转
export const loginJump = () => {
  const liveRoom = JSON.parse(window.sessionStorage.getItem('liveRoom'));
  if (liveRoom) {
    router.push({
      name: 'Live',
      query: { ...liveRoom },
    });
  } else {
    router.push({
      name: 'videoList',
    });
  }
};

// 密码验证
export const testPwd = pass => {
  var reg = new RegExp('(?!.*[\u4E00-\u9FA5\\s])(?!^[a-zA-Z]+$)(?!^[\\d]+$)(?!^[^a-zA-Z\\d]+$)^.{8,20}$');
  if (!reg.test(pass)) {
    return false;
  }
  return true;
};

// 时间转换
export const formatMsgTime = dateTimeStamp => {
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  var result;
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (monthC >= 1) {
    result = '' + parseInt(monthC) + '月前';
  } else if (weekC >= 1) {
    result = '' + parseInt(weekC) + '周前';
  } else if (dayC >= 1) {
    result = '' + parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    result = '' + parseInt(hourC) + '小时前';
  } else if (minC >= 1) {
    result = '' + parseInt(minC) + '分钟前';
  } else result = '刚刚';
  return result;
};

// 设置微医H5的测试,线上地址
export const wyH5URL = () => {
  // APP嵌入页面
  if (vue.$UA.isUserApp) {
    // 线上环境并且安卓
    if (process.env.NODE_ENV !== 'development' && vue.$UA.isAndroid) {
      return 'https://doctorbridge.wy.guahao.com/user/login?';
    }
    return '/user/login?';
  }

  let wxLoginURL = document.referrer;

  if (!wxLoginURL || wxLoginURL.indexOf('bridge') !== -1) {
    if (process.env.NODE_ENV === 'development') {
      wxLoginURL = 'http://wy.guahao-test.com/';
    } else {
      wxLoginURL = 'https://wy.guahao.com/';
    }
  }

  if (wxLoginURL.indexOf('?') !== -1) {
    wxLoginURL = wxLoginURL.split('?')[0];
  }
  if (isWeChatClient && window.sessionStorage.getItem('wyDbAuthtoken')) {
    // 微信跳转地址
    wxLoginURL += 'wx/auth?case=1&disableTemp=1&';
  } else {
    wxLoginURL += 'user/login?';
  }

  return wxLoginURL;
};

// 跳转到登录页面
export const goLoginUrl = () => {
  window.location.href = `${wyH5URL()}target=${encodeURIComponent(window.location.href)}`;
};

var isShowAPPshare = true;
// 唤起微医app分享
export const callAPPshare = (params, { imgUrl, title, desc }, callBack) => {
  if (!isShowAPPshare) return;
  isShowAPPshare = false;
  let itemList = {
    itemList: [
      {
        type: 'wx',
        icon: 'https://kano.guahao.com/0QQ331748967',
        name: '微信',
      },
      {
        type: 'pyq',
        icon: 'https://kano.guahao.com/ykg331749880',
        name: '朋友圈',
      },
      {
        type: 'videoReport',
        icon: 'https://kano.guahao.com/lhl322205686',
        name: '举报',
      },
    ],
  };
  // if (params.fileUrl) {
  //   itemList = {
  //     itemList: [
  //       {
  //         type: 'base:shareWeixinTimeline',
  //       },
  //       {
  //         type: 'base:shareWeixinMessage',
  //       },
  //       {
  //         type: 'videoSave',
  //         icon: 'https://kano.guahao.com/Hct322207108',
  //         name: '保存至相册',
  //       },
  //       {
  //         type: 'videoReport',
  //         icon: 'https://kano.guahao.com/lhl322205686',
  //         name: '举报',
  //       },
  //     ],
  //   };
  // }
  if (params.type === 'live') {
    itemList = {
      itemList: [
        {
          type: 'wx',
          icon: 'https://kano.guahao.com/0QQ331748967',
          name: '微信',
        },
        {
          type: 'pyq',
          icon: 'https://kano.guahao.com/ykg331749880',
          name: '朋友圈',
        },
      ],
    };
  }
  // 设置分享栏属性
  vue.$bridge.emit('setPopupShareItems', itemList, function() {
    const fullPath = router.history.current.fullPath;
    const { snowId } = router.history.current.query;
    isShowAPPshare = true;
    // 调起分享栏
    vue.$bridge.emit('showShareView');
    vue.$bridge.on('onNavigationBarCustomButtonsClick', val => {
      // if (val.type === 'videoSave') {
      //   vue.$bridge.emit(
      //     'saveImage',
      //     {
      //       data: videoUrl,
      //       type: 'video',
      //     },
      //     function(value) {
      //       console.log(value);
      //     },
      //     function(err) {
      //       console.log(err);
      //     },
      //   );
      // }
      const params = {
        shareTo: 'weixin',
        title,
        desc,
        link: window.location.href,
        imgUrl,
      };
      if (val.type === 'pyq') {
        params.shareTo = 'timeline';
      }
      // 分享朋友圈,朋友圈
      if (val.type === 'pyq' || val.type === 'wx') {
        apiShareVideoInfo({
          snowId,
        }).then(() => {
          callBack && callBack();
          vue.$bridge.emit('onMenuShare', params);
        });
      }
      // 举报
      if (val.type === 'videoReport') {
        let videoType = 2;
        if (fullPath.indexOf('live') !== -1) {
          videoType = 1;
        }
        if (!window.sessionStorage.getItem('wyDbAuthtoken')) {
          goLoginUrl();
        }
        window.location.href = `/app/report?videoId=${snowId}&videoType=${videoType}`;
      }
    });
  });
};

export const setSource = router => {
  if (router.name) {
    store.commit('changeSeting', { key: 'appRoute', value: false });
    if (router.name.indexOf('app') === 0) {
      store.commit('changeSeting', { key: 'appRoute', value: true });
    }
  }
};

// 微医H5获取Cookie,设置token
export const wySetToken = router => {
  if (store.state.appRoute) {
    // 微医登录
    const wytoken = vue.$cookies.get('__wyt__');
    wytoken
      ? window.sessionStorage.setItem('wyDbAuthtoken', wytoken)
      : window.sessionStorage.setItem('wyDbAuthtoken', '');
    const appid = vue.$cookies.get('__appid__');
    if (appid) {
      window.sessionStorage.setItem('appid', appid);
    } else if (vue.$UA.isUserApp) {
      window.sessionStorage.setItem('appid', '');
    } else {
      window.sessionStorage.setItem('appid', 'p_h5_weiyi');
    }
  } else {
    // 微医直播app
    window.sessionStorage.setItem('appid', '');
  }
};

// 设置来源标识
export const wySetSign = router => {
  if (store.state.appRoute) {
    if (vue.$UA.isUserApp) {
      // 微医APP打开
      store.commit('changeSeting', { key: 'channel', value: 'weiyi' });
    } else {
      // 微医H5打开
      store.commit('changeSeting', { key: 'channel', value: 'weiyi_h5' });
    }
  } else {
    // 分享页面
    store.commit('changeSeting', { key: 'channel', value: '' });
  }
};

// 微医方: app内和H5页面跳转
export const appPageJump = (url, params) => {
  if (vue.$UA.isUserApp) {
    const pageParams = {
      url: `${window.location.origin}${url}?${qs.stringify(params)}`,
    };
    vue.$bridge.emit(
      'pushWindow',
      pageParams,
      function(val) {
        console.log(val);
      },
      function(err) {
        console.log(err);
      },
    );
  } else {
    router.push({
      path: url,
      query: params,
    });
  }
};

export const nickNamefilter = nickName => {
  if (validatePhoneNumber(nickName)) {
    return `${nickName.substr(0, 3)}****${nickName.substr(7)}`;
  }
  return nickName;
};
// 保留几位小数（四舍五入）
export const getFloat = function(num, n) {
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(num);
  }
  num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
  num = Number(num).toFixed(n); //补足位数
  return num;
};
